import { ToastNotificationType } from '@modules/common/components/Notification/NotificationContext';
import { getNotificationToastPositionValues } from '@modules/common/components/Notification/utils';
import { styled } from '@mui/material';
import { LeftOffset } from './utils/types';

interface NotificationsContainerProps {
  notificationType?: ToastNotificationType;
  leftOffset?: LeftOffset;
  notificationIndex: number;
  numberOfActiveNotifications: number;
}

export const NotificationsContainer = styled('div')(
  ({
    notificationType,
    leftOffset,
    notificationIndex,
    numberOfActiveNotifications,
  }: NotificationsContainerProps) => ({
    position: 'fixed',
    maxWidth: '40%',
    zIndex: 3000,
    ...getNotificationToastPositionValues(
      notificationType ?? ToastNotificationType.DefaultNotification,
      notificationIndex,
      numberOfActiveNotifications,
      leftOffset,
    ),
  }),
);
